import { z } from "zod";
import { wishlistItem } from "./wishlistItem";

export const sharedWishlist = z.object({
  id: z.number().optional(),
  name: z.string().optional(),
  shareLink: z.string().optional().nullable(),
  wishlistItems: z.array(wishlistItem),
});

export type SharedWishlist = z.infer<typeof sharedWishlist>;
